/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import React from "react";
import HomePanel from "../../components/home/homePanel";
import {withPrefix} from "gatsby";
import {Row, Column} from 'gatsby-theme-carbon';
import CardLeft from "../../visuals/homepage/card-back-1.png";
import CardMiddle from "../../visuals/homepage/card-back-2.png";
import CardRight from "../../visuals/homepage/card-back-3.png";
import {ResourceCard} from 'gatsby-theme-carbon';
import "./home-cards.scss";
const MDXLayout = ({children, _frontmatter}) => React.createElement(React.Fragment, null, children);
function _createMdxContent(props) {
  return React.createElement(Row, {
    className: "resource-card-group-3-across"
  }, React.createElement(Column, {
    colSm: 4,
    colMd: 4,
    colLg: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Equal Access Toolkit",
    href: "/toolkit",
    aspectRatio: "1:1",
    actionIcon: "arrowRight"
  })), React.createElement(Column, {
    colSm: 4,
    colMd: 4,
    colLg: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Requirements",
    href: "/requirements/requirements",
    aspectRatio: "1:1",
    actionIcon: "arrowRight"
  })), React.createElement(Column, {
    colLg: 4,
    colMd: 4,
    colSm: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Product Accessibility (ACR/VPAT)",
    href: "/product_accessibility",
    aspectRatio: "1:1",
    actionIcon: "arrowRight"
  })));
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
